﻿'use strict';

angular.module('ntmApp').factory('ExportOptionsCustomizer', ['$filter', function ($filter) {

    var customizer = {};

    customizer.buildOptions = function (gridOptions) {

        gridOptions = gridOptions || {};

        gridOptions.exporterFieldCallback = function (grid, row, col, value) {

            if (col.colDef.type === 'boolean') {
                return value === 0 ? 'No' : 'Yes';
            }

            if (col.colDef.type === 'date') {
                return $filter('date')(value, 'MM/dd/yyyy');
            }

            return value;
        };

        return gridOptions;
    };

    return customizer;

}]);